var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('data-viz-panel');
import { breakpoints, theme } from '@shapeable/theme';
import { HidePanelButton } from '../elements/hide-panel-button';
import { useDataViz } from '../hooks/use-data-viz';
import { RadarIconGlyph } from '@shapeable/icons';
import { useEnv } from '../hooks/use-env';
export var DataVizPanelDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #969696;\n    position: relative;\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n  "], ["\n    background: #969696;\n    position: relative;\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n  "])))
});
var HideButtonStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    display: none;\n  "], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    display: none;\n  "]))),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var HideButtonHorizontalStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 44px;\n  "], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 44px;\n  "]))),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var DataVizStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n    position: absolute;\n    top: 44px;\n    width: 100%;\n    height: calc(100% - 44px);\n    box-sizing: border-box;\n\n    svg {\n      height: 100%;\n      width: 100%;\n    }\n  "], ["\n    padding: ", ";\n    position: absolute;\n    top: 44px;\n    width: 100%;\n    height: calc(100% - 44px);\n    box-sizing: border-box;\n\n    svg {\n      height: 100%;\n      width: 100%;\n    }\n  "])), theme.UNIT(1)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    left: 54px;\n    top: 0;\n    height: 100%;\n    width: calc(100% - 54px);\n  "], ["\n    left: 54px;\n    top: 0;\n    height: 100%;\n    width: calc(100% - 54px);\n  "]))),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  HideButton: styled(HidePanelButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), HideButtonStyles),
  DataVizContainer: styled.div.attrs(cls.attr('data-viz-container'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), DataVizStyles),
  HideButtonHorizontal: styled(HidePanelButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), HideButtonHorizontalStyles)
};
export var DataVizPanel = function (props) {
  var className = props.className,
    onClick = props.onClick,
    children = props.children,
    dataViz = props.dataViz,
    visibility = props.visibility;
  var viz = visibility || useDataViz();
  var ref = viz.useClickOutside();
  var env = useEnv();
  var hideButtonLabel = env.DATA_VIZ_PANEL_HIDE_LABEL || props.hideLabel || 'Hide Visualisation';
  var icon = props.icon || React.createElement(RadarIconGlyph, null);
  return React.createElement(My.Container, {
    ref: ref,
    onClick: onClick,
    className: cls.name(className)
  }, React.createElement(My.HideButtonHorizontal, {
    label: hideButtonLabel,
    icon: icon,
    onClick: viz.hideOnClick
  }), React.createElement(My.HideButton, {
    label: hideButtonLabel,
    icon: icon,
    isVertical: true,
    onClick: viz.hideOnClick
  }), React.createElement(My.DataVizContainer, null, dataViz || children));
};
DataVizPanel.cls = cls;
DataVizPanel.defaultProps = DataVizPanelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;